// https://github.com/jpalumickas/use-window-focus/blob/main/src/index.ts

import { useState, useEffect } from 'react';

export const useWindowVisible = () => {
  const [visible, setVisible] = useState(!document['hidden']); // Focus for first render

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange, false);
    window.addEventListener('focus', handleVisibilityChange, false);

    return () => {
      window.removeEventListener('visibilitychange', handleVisibilityChange, false);
      window.removeEventListener('focus', handleVisibilityChange, false);
    };
  }, []);

  return visible;
};
